<template>
  <SvgBase iconName="IconStar" :height="20" :width="20" viewBoxWidth="24" viewBoxHeight="24">
    <path
      d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      :fill="fill"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </SvgBase>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    fill: {
      type: String,
      default: 'none',
    },
  },
})
export default class IconStar extends Vue {}
</script>
